import React from 'react';
import { string, bool, func } from 'prop-types';
import classNames from 'classnames/bind';

import SocialSharingList from 'components/SocialSharingList';
import Button from 'components/Button';

import IconShare from 'media/icons/share.icon.svg';
import styles from './SocialShareButton.module.scss';

const cx = classNames.bind(styles);

const SocialShareButton = ({
  className,
  pageTitle,
  setIsShownSharing,
  isShownSharing,
}) => {
  const toggleSharing = () => {
    setIsShownSharing(!isShownSharing);
  };

  return (
    <div className={cx('share-container', className)}>
      {isShownSharing && (
        <SocialSharingList
          pageTitle={pageTitle}
          className={cx('share-listing')}
        />
      )}
      <Button
        className={cx('button-share')}
        onClick={toggleSharing}
      >
        <span className={cx('btn-text')}>Share</span>
        <span className={cx('btn-icon', 'icon-arrow')}>
          <IconShare />
        </span>
      </Button>
    </div>
  );
};

SocialShareButton.propTypes = {
  className: string,
  pageTitle: string.isRequired,
  isShownSharing: bool,
  setIsShownSharing: func.isRequired,
};

SocialShareButton.defaultProps = {
  className: null,
  isShownSharing: false,
};

export default SocialShareButton;



// WEBPACK FOOTER //
// ./src/components/SocialShareButton/SocialShareButton.js